import React from 'react';
import SubNews from './SubNews.jsx';
import NewsCategoryMenu from './NewsCategoryMenu.jsx';
import style from './style.scss';
import {Articles} from 'api';
import {DateTime} from 'components/UI/DateTime';

class NewsDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <section className="news-detail">
        <div className='center'>
          <div className='news-container'>
            <div className='news-left-menu '>
              <NewsCategoryMenu/>
            </div>
            <div className='news-right-content'>
              <h2 className='news-detail-title'>{this.props.article.title}</h2>
              <p className='news-detail-time'><DateTime dateTime={this.props.article.updatedAt}/></p>
              <div className='news-detail-content' dangerouslySetInnerHTML={{
                __html: this.props.article.content
              }}></div>
            </div>
          </div>

        </div>
        {/* <div className='another-news'>
          <h3 className='another-news-title'>Các tin khác</h3>
          <div className='another-news-wrap'>
            {
              this.props.articleSubNews.map((item, i) => {
                return (
                  <SubNews key={i} {...item}/>
                )
              })
            }
          </div>
        </div> */}
      </section>
    );
  }
}

export default NewsDetail;



// WEBPACK FOOTER //
// ./components/news/NewsDetail.jsx